import { render } from "./tableRowTube.vue?vue&type=template&id=bfbfcbe0"
import script from "./tableRowTube.vue?vue&type=script&lang=js"
export * from "./tableRowTube.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__